export const NPS_COOLDOWN_DAYS = 90;
export const NPS_COOLDOWN_MS = NPS_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
export const NPS_TRIGGER_DELAY_MS = 3000;
export const NPS_COMMENT_MAX_CHARS = 1000;
export const NPS_DETRACTOR_MAX = 6;
export const NPS_PASSIVE_MAX = 8;
export const NPS_THANK_YOU_DELAY_MS = 2000;

export const NPS_MILESTONES = {
  COMPLETED_FIRST_ANALYSIS: "completed_first_analysis"
} as const;
